import React, { useState } from 'react';
import { AffirmationWithCategory } from '../../../interfaces/tell_me/affirmationWithCategory.types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import * as Papa from 'papaparse';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Box, List } from '@material-ui/core';
import AddAffirmationDialog from './Add_Dialog';
import { addAffirmations } from '../../../api/api';
import { getDataSetToRedux } from '../../../utility/getAffirmationAndCategory';
import { AppState } from '../../../store/store';

const useStyles = makeStyles({
    table: {
        minWidth: 1200,
    },
});


function AffirmationAddComponent() {

    const dispatch = useDispatch();
    const allAffirmations = useSelector((state: AppState) => state.affirmations);
    const classes = useStyles();
    const [newAffirmations, setNewAffirmations] = useState<Array<AffirmationWithCategory>>([]);

    const [openAddDialog, setAddOpenDialog] = React.useState(false);

    const handleDialogOnSubmit = (affirmation: AffirmationWithCategory) => {
        setAddOpenDialog(false);
        const list = [...newAffirmations, affirmation];
        setNewAffirmations(list);
        alert("Do not forget to Save!")
    }

    const handleCSVChosen = async (file: File) => {
        try {
            const affirmationList: Array<AffirmationWithCategory> = [];
            // Parse and add affirmations to the list;
            Papa.parse(file, {
                complete: function (results) {
                    results.data.forEach((e: any) => {
                        if (e[0] !== 'text') {
                            const categories = e[1].split(',');
                            affirmationList.push({
                                text: e[0],
                                id: uuidv4(),
                                categoryIds: categories,
                            });
                        }
                    })
                    // Set To List
                    const list = [...newAffirmations, ...affirmationList];
                    setNewAffirmations(list);
                },
            });
        } catch (error) {
            console.log(error);
            console.log("Error in Parsing");
        }

    };


    const saveNewAffirmations = async () => {
        if (newAffirmations.length > 0) {

            // if the some of the new affirmations are already in the all affirmations, get these affirmations.
            const previouslyAddedAffirmations = newAffirmations.filter(newAffirmation => {
                const allAffirmationsText = allAffirmations.map(e => e.text);
                return allAffirmationsText.includes(newAffirmation.text);
            });

            // Remove the previously added affirmations from the newAffirmations list.
            previouslyAddedAffirmations.forEach(affirmation => {
                const deleteIndex = newAffirmations.findIndex(newAffirmation => newAffirmation.text === affirmation.text);
                if (deleteIndex !== -1) {
                    newAffirmations.splice(deleteIndex, 1);
                }
            });

            // show a warning message
            // they should be updated by update dialog.
            let errorMessage = "";
            if (previouslyAddedAffirmations.length > 0) {
                errorMessage = "Errors: " + previouslyAddedAffirmations.map(e => e.text).join("\n") + "\n *These affirmations are already saved. Please update these affirmations on table!";
            }


            const response = await addAffirmations(newAffirmations);
            await getDataSetToRedux(dispatch);
            if (response.success) {
                alert("SUCCESS \n " + errorMessage);
            } else {
                alert("ERROR");
            }
            setNewAffirmations([]);
        }
    }



    return (
        <div style={{ margin: 10 }}>
            <h2> Add Affirmation </h2>

            {/* READ CSV */}
            <input
                type='file'
                id='file'
                className='input-file'
                accept='.csv'
                onChange={(e) => {
                    if (e.target.files) {
                        const file = e.target.files[0]
                        handleCSVChosen(file);
                    }
                }}
            />

            {/* Add By Dialog */}
            <Button style={{ marginLeft: 35, margin: 10, }} variant="outlined" onClick={() => setAddOpenDialog(true)}>
                Add By Dialog
            </Button>

            {/* Affirmation List */}
            <TableContainer style={{ maxHeight: 420 }} component={Paper} >
                <List>
                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Text</TableCell>
                                <TableCell align="right">id</TableCell>
                                <TableCell align="right">categories</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {newAffirmations.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {row.text}
                                    </TableCell>
                                    <TableCell align="right">{row.id}</TableCell>
                                    <TableCell align="right">
                                        <Box maxWidth={300}>
                                            {[...row.categoryIds].join(', \n')}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </List>
            </TableContainer>

            {/* Add Affirmation Dialog */}
            <AddAffirmationDialog
                open={openAddDialog}
                onSubmit={handleDialogOnSubmit}
                handleClose={() => setAddOpenDialog(false)}
            />


            <Button style={{ margin: 25, }} variant="contained" onClick={saveNewAffirmations}>
                SAVE!
            </Button>


        </div>
    );
}


export default AffirmationAddComponent;